module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAAXNSR0IArs4c6QAAAN1JREFUKBWdkzEORUAYhAdLoqBQOIFzOIJSr9I5ic4B3EWidgEuoFJRiLz3ZvNI/oRsYppJ5p9vl7Wsz094IfsFoxF1gnVdw7ZtuK6LdV3BBzmOA47jQCml833fEQQByrLEBXqeh6qqznUevWkauWPf93rlR+I/GIZBgmmaoigK+L6Pbdse/TxLcTh8J8rk7AiQh0KZnB0BxnHMDCZnR4DzPDODydkRYBiGzGBydgTID0yZnJ3rAnRdh2makCQJ81uN44hlWfTsArMs09cqz/NbiGHbtoiiSM+tt3/HFzJfelcc5lUGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/seccionales.png
// module id = 515
// module chunks = 0